<template>
  <Products :listTitle="listTitle" :content="content"/>
</template>

<script>
export default {
  data () {
    return {
      listTitle: '多物理计算系统',
      content: '<div style="font-size:16px;text-indent:2em;">dpiSolve 是一款通用的前后处理软件，用于求解多物理耦合、求解数学方程组、求解离散型数值系统、高级计算系统、微分方程求解系统、有限元、有限体积、物质点、边界元等方法的求解系统。</div><br /><br /><img src="../products/多物理.png" style="width:500px;height:300px;margin:10px 100px;">'
    }
  }
}
</script>
